import { render } from "./ProductView.vue?vue&type=template&id=7e0efe6d&scoped=true&ts=true"
import script from "./ProductView.vue?vue&type=script&lang=ts"
export * from "./ProductView.vue?vue&type=script&lang=ts"

import "./ProductView.vue?vue&type=style&index=0&id=7e0efe6d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0efe6d"]])

export default __exports__